import { Link, useParams } from "react-router-dom";
import ScrollToHashElement from "@cascadia-code/scroll-to-hash-element";
import parse from 'html-react-parser';
import store from "../../../_services/store";
import styled from "styled-components";
import { COLORS } from "../../../constants";
import BackButton from "../../_ui/back-button";
import { Image } from "../../_ui";
import { observer } from "mobx-react";
import { useEffect } from "react";
import labels from '../../../_translations/symptom.json';
import PageNotFound from "../../_ui/page-not-found";
const RoundNumber = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  padding: 3px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 20px;
  background: ${COLORS.PRIMARY};
  color: ${COLORS.WHITE};
`;

const MenuTitle = styled.h3`
  color: ${COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
`;

const MenuContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin: 0px;
  text-decoration: none;
`;

const SectionContainer = styled.div`
  padding: 0px 20px;
  color: ${COLORS.DARK};
`;

const SymptomSection = observer(({ section }: { section: TSymptomSection }) => {
  return (
    <SectionContainer>
      <h3 id={`section_${section.id}`}>{section.title}</h3>
      {section.photos.length > 0 && (
        <div style={{ margin: '20px 0' }}>
          <Image src={section.photos[0].label} width="350px" height="auto" style={{ borderRadius: '8px' }} />
          {section.photos[0].legend && (
            <p style={{ fontSize: '12px', fontStyle: 'italic', color: COLORS.SECONDARY, marginTop: '8px' }}>
              {section.photos[0].legend}
            </p>
          )}
        </div>
      )}
      {parse(section.content)}
    </SectionContainer>
  )
})

const SymptomDetail = observer(() => {
  const { id } = useParams();
  const detail: TSymptomDetail = store.symptomeDetail as TSymptomDetail;
  store.addViewedSymptom(id);

  useEffect(() => {
    if (id) {
      store.getSymptomesDetailsForId(+id)
    }
  }, [id]);


  if (!detail) {
    return (
      <div className="fadeIn" style={{ marginBottom: '120px', height: 'auto' }}>
        <BackButton title={labels[store.currentLanguage].buttons.back} />
        <PageNotFound />
      </div>
    )
  }

  const menu = detail?.sections?.map((section, i) =>
    <Link
      key={`section_menu_${section.id}`}
      to={`#section_${section.id}`}
      replace
      style={{ textDecoration: 'none' }}
    >
      <MenuContainer >
        <RoundNumber>{i}</RoundNumber>
        <MenuTitle>{section.title}</MenuTitle>
      </MenuContainer>
    </Link>
  );

  const sections = detail?.sections?.map(section => <SymptomSection key={`section_${section.title}`} section={section} />);

  if (!sections) {
    return (
      <div className="fadeIn" style={{ marginBottom: '120px', height: 'auto' }}>
        <BackButton title={labels[store.currentLanguage].buttons.back} />
        <PageNotFound />
      </div>
    )
  }

  return (
    <div className="fadeIn" style={{ marginBottom: '120px', height: 'auto' }}>
      <BackButton title={detail.title} />
      <ScrollToHashElement behavior="smooth" />
      {menu}
      {sections}
    </div>
  )
})

export default SymptomDetail;